export const TIMEZONES = {
  'Europe/Berlin': "Europa/Berlin (MEZ)",
  'UTC': "UTC",
  'Etc/GMT-1': "Etc/GMT-1 (entspricht MEZ, Winterzeit)",
  'Etc/GMT-2': "Etc/GMT-2 (entspricht MESZ, Sommerzeit)",
};
